import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppConfig, SystemHeader } from '../../../service/DTOs';
import * as TF from '../../../service/tradeflow';
import * as DTO from '../../../service/DTOs';
import * as API from '../../../service/apisvc';
import * as RB from 'react-bootstrap';
import * as Actions from '../../../service/Actions';
import * as Dispatch from '../../../service/Dispatcher';
import { CAInstrumentLimitMargin, CAInstrumentLimitMarginPropsState } from './../CAInstrumentLimitMargin';



type EntityLimitsRecordProps = Actions.OrderState & { xsrfToken?: string }
    & { record: DTO.EntityWLimits } & { entitySelected: any } & { entityRemove: any }
    //& { limitCtxRemove: any } & { limitCtxAppend: any }
    & { limitsCreate: any } & { limitApplyChange: any } 
    & { currencies: DTO.Currency[] }
    //& { durations: DTO.Duration[] }
    & { instruments: DTO.InstrumentHead[] }
    ;

type EntityLimitsRecordState = Actions.OrderState & { marginTo?: DTO.NotesContragentMargin };


export const initialstate_entitylimitsrecord: Actions.OrderState = {
    processing: false,
    haserrors: false,
    modified: false,
    selected: false
}



export class EntityLimitsRecord extends React.Component<EntityLimitsRecordProps, EntityLimitsRecordState> {
    constructor(props: EntityLimitsRecordProps) {
        super(props);
        this._marginPickChange.bind(this);

        //props.record.marginTo !== this.state.marginTo

        this.state = {
            ...initialstate_entitylimitsrecord, ...{ processing: props.processing, haserrors: props.haserrors, modified: props.modified, marginTo: props.record.marginTo }
        };

        //console.log('EntityLimitsRecord - constructor');
        //console.log(props.record.marginTo);
    }

    //handleReloadRecord(record: DTO.EntityWLimits) {
    //    this.mergeMarginChanges(record);
    //}

    //mergeMarginChanges(record: DTO.EntityWLimits) {
    //    if (record.marginTo) {
    //        record.marginTo.margins.map((v, idx) => {
    //            if (this.state.marginTo) {
    //                let stm = this.state.marginTo.margins.find(obj => obj.id == v.id);
    //                if (!stm) {
    //                    this.state.marginTo.margins.push(v);
    //                }
    //            }
    //        });

    //        if (this.state.marginTo) {
    //            this.state.marginTo.margins.map((v, idx) => {
    //                if (record.marginTo && record.marginTo.margins) {
    //                    let rtm = record.marginTo.margins.find(obj => obj.id == v.id);
    //                    if (!rtm && this.state.marginTo) {
    //                        this.state.marginTo.margins.splice(idx, 1);
    //                    }
    //                }
    //            });
    //        }

    //    }
    //}

    componentWillReceiveProps(nextProps: EntityLimitsRecordProps) {
        this.setState(nextProps);
        if (this.props.record !== nextProps.record) {
            this.setState({ marginTo: nextProps.record.marginTo });
            //console.log('componentWillReceiveProps - unmatch');
            //console.log(nextProps.record.marginTo);
        }
    }

    _onSelectSec = (locatorId: string, record: DTO.EntityWLimits) => {
        return this.props.entitySelected(locatorId, record);
    }

    _onRemoveSec = (locatorId: string, record: DTO.EntityWLimits) => {
        return this.props.entityRemove(locatorId, record);
    }

    _onCreateLimits = (locatorId: string, record: DTO.EntityWLimits) => {
        return this.props.limitsCreate(locatorId, record);
    }    

    _onRemoveLimitContext = (locatorId: string, marginpick: DTO.NotesContragentMarginPick) => {
        //console.log('_onRemoveLimitContext');
        //console.log(marginpick);

        if (this.state.marginTo) {
            let idxFound = this.state.marginTo.margins.findIndex(v => v.idinstrument == marginpick.idinstrument);
            if (idxFound >= 0) {
                //console.log('_onRemoveLimitContext found');
                this.state.marginTo.margins.splice(idxFound, 1);
                //console.log(this.state.marginTo);

                this.setState({
                    marginTo: Object.assign({}, this.state.marginTo) });
            }

            //return this.props.limitCtxRemove(locatorId, marginpick);
            //return this.props.limitCtxRemove(this.props.record, marginpick);
        }
    }

    _onAppendLimitContext = (locatorId: string, ins: DTO.InstrumentHead) => {
        if (this.state.marginTo) {
            let pick: DTO.NotesContragentMarginPick = {
                idinstrument: ins.id,
                givemargin: 0,
                free2givedeal: 0,
                free2giveorder: 0,
                givendeal: 0,
                givenorder: 0,
                id: 0
            };
            this.state.marginTo.margins.push(pick);

            this.setState({
                marginTo: Object.assign({}, this.state.marginTo)
            });
        }

        //return this.props.limitCtxAppend(this.props.record, cur, dur);
    }

    _onApplyLimitChange = (locatorId: string, margin: DTO.NotesContragentMargin) => {
        try {
            this.setState({ processing: true });

            return this.props.limitApplyChange(this.props.record, margin);
        }
        finally {
            this.setState({ processing: false });
        }
    }
    
    handleChangeMarginProp = (e: any) => {
        //console.log(e);
        if (this.state.marginTo) {
            let mgnTo = { ...this.state.marginTo, ...{ [e.target.name]: e.target.value } }        
            this.setState({ marginTo: mgnTo });
        }        
    }


    //<td style={{ textAlign: 'right', width: '20px', gridRowSpan: rspan }} >
    //    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
    //        <RB.Button title='Исключить' disabled={this.state.processing} onClick={this._onRemoveSec.bind(this, '' + this.props.record.id, this.props.record)}><RB.Glyphicon glyph="minus" /></RB.Button>
    //    </RB.ButtonGroup>
    //</td>

    //<td style={{ textAlign: 'right', width: '10%', gridRowSpan: rspan }} >
    //    {this.props.record.shortname}{'('}{this.props.record.reutercode}{')'}
    //</td>

    //processMarginChange(newgivemargin: number | undefined) {
    //    if (this.state.marginpick) {
    //        let mp = this.state.marginpick;
    //        mp.givemargin = newgivemargin ? newgivemargin : 0;
    //        this.setState({ marginpick: mp });
    //    }
    //}


//            <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'} style={{ zIndex: 10, position: "relative", left: '25px' }}>
//    <RB.Button title='Закрыть лимит' disabled={this.state.processing} onClick={this._onRemoveLimitContext.bind(this, '' + margin.id, margin)}><RB.Glyphicon glyph="remove" /></RB.Button>
//</RB.ButtonGroup>

    _marginPickChange(marginpick: DTO.NotesContragentMarginPick, marginVal?: number) {
        if (this.state.marginTo) {
            let mgnTo = Object.assign({}, this.state.marginTo);

            let margin = mgnTo.margins.find(obj => { return obj.idinstrument == marginpick.idinstrument });
            if (margin) {
                margin.givemargin = marginVal ? marginVal : 0;

                this.setState({ marginTo: mgnTo});
            }

            //this._checkModify();
        }
    }

    //_renderCurrencyDirectionDurationCol(mgn: DTO.NotesContragentMargin | undefined, cur: DTO.Currency, dur: DTO.Duration, moneyOut: boolean, idx: number, totalCols: number) {
    //    let margin = mgn ? mgn.margins.map(x => x).find(obj => { return obj.idcurrency == cur.id && obj.idduration == dur.id }) : undefined;
    //    let widPerc = 100.0 / totalCols;


    //    let contextGiveMarginsToCA = margin ?
    //        <div>
    //            {moneyOut ?
    //                <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'} style={{ zIndex: 10, position: "relative", left: '25px' }}>
    //                    <RB.Button title='Закрыть лимит' disabled={this.state.processing} onClick={this._onRemoveLimitContext.bind(this, '' + margin.id, margin)}><RB.Glyphicon glyph="remove" /></RB.Button>
    //                </RB.ButtonGroup>
    //                : undefined}
    //            <CAInstrumentLimitMargin key={'CAInstrumentGiveMargin'} currency={cur} duration={dur} showCurrency={false} showDuration={false} compact={true}
    //                marginpick={margin} editMargin={moneyOut}
    //                processMarginChange={(newmvalue) => { if (margin) this._marginPickChange(margin, newmvalue ); }}
    //            /></div>
    //        :
    //        moneyOut ?
    //            <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.processing} onClick={this._onAppendLimitContext.bind(this, '' + this.props.record.id, cur, dur)}>
    //                {'Не определен'}
    //            </RB.Button>
    //            :
    //            <RB.Label bsStyle="default">Не определен</RB.Label>;

    //    return <td style={{ width: widPerc + '%' }} key={this.props.record.id + ':' + cur.id + ':' + dur.id}>
    //        {contextGiveMarginsToCA}
    //    </td>;
    //}

    _renderInstrumentCol(mgn: DTO.NotesContragentMargin | undefined, ins: DTO.InstrumentHead, moneyOut: boolean, idx: number, totalCols: number) {
        //let margin = mgn? mgn.margins.map(x => Object.assign({}, x)).find(obj => { return obj.idcurrency == cur.id && obj.idduration == dur.id }) : undefined;
        let margin = mgn ? mgn.margins.map(x => x).find(obj => { return obj.idinstrument == ins.id }) : undefined;
        let widPerc = 100.0 / totalCols;


        let contextGiveMarginsToCA = margin ?
            <div>
                {moneyOut ?
                    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'} style={{ zIndex: 10, position: "relative", left: '25px' }}>
                        <RB.Button title='Закрыть лимит' disabled={this.state.processing} onClick={this._onRemoveLimitContext.bind(this, '' + margin.id, margin)}><RB.Glyphicon glyph="remove" /></RB.Button>
                    </RB.ButtonGroup>
                    : undefined}
                <CAInstrumentLimitMargin key={'CAInstrumentGiveMargin'} instrument={ins} showCurrency={false} showInstrument={false} compact={true} twolines={true}
                    marginpick={margin} editMargin={moneyOut}
                    processMarginChange={(newmvalue) => { if (margin) this._marginPickChange(margin, newmvalue); }}
                /></div>
            :
            moneyOut ?
                <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.processing} onClick={this._onAppendLimitContext.bind(this, '' + this.props.record.id, ins)}>
                    {'Не определен'}
                </RB.Button>
                :
                <RB.Label bsStyle="default">Не определен</RB.Label>;

        return <td style={{ width: widPerc + '%' }} key={this.props.record.id + ':' + ins.id }>
            {contextGiveMarginsToCA}
        </td>;
    }

    //_renderCurrencyRow(cur: DTO.Currency, idx: number) {
    //    //curListTo = this.props.record.marginTo.margins.map(x => { return this.props.currencies.find(obj => { return obj.id == x.idcurrency }) }).sort((a, b) => { return a && b ? (a.shortname > b.shortname ? 1 : (b.shortname > a.shortname ? -1 : 0)) : 0; });

    //    //let durList = this.props.durations;
    //    let insList = this.props.instruments;
    //    let dlen = insList.length;

    //    let trStyle = idx == 0 ? { borderBottom: '0.5px solid rgb(221, 221, 221)' } : undefined;
    
    //    //<span>Не установлено</span>
    //    //bsStyle = "info"
    //    return <tr key={this.props.record.id + ':' + cur.id} style={trStyle}>
    //        <td style={{ textAlign: 'center', width: '50px' }}>{cur.shortname}</td>
    //        <td style={{ textAlign: 'center', width: 'calc(50% - (50px/2))' }}>
    //            {insList.length > 0 && this.state.marginTo ?
    //                <table className='table-bdr' style={{ width: '100%' }}><tbody ><tr style={{ width: '100%' }}>
    //                    {insList.map((x, i) => this._renderInstrumentCol(this.state.marginTo, cur, x, true, i, dlen))}
    //                </tr></tbody></table>
    //                : (idx == 0) ?
    //                    <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.processing} onClick={this._onCreateLimits.bind(this, '' + this.props.record.id, this.props.record)}>
    //                        <RB.Glyphicon glyph="plus" />{' Создать лимиты'}
    //                    </RB.Button>
    //                    : undefined
    //            }
    //        </td>
    //        <td style={{ textAlign: 'center', width: 'calc(50% - (50px/2))' }}>
    //            {insList.length > 0 && this.props.record.marginFrom ?
    //                <table className='table-bdr' style={{ width: '100%' }}><tbody ><tr style={{ width: '100%' }}>
    //                    {insList.map((x, i) => this._renderInstrumentCol(this.props.record.marginFrom, cur, x, false, i, dlen))}
    //                </tr></tbody></table>
    //                : (idx == 0) ? <span><RB.Label bsStyle="default">{'Не установлено'}</RB.Label></span> : undefined
    //            }
    //        </td>
    //    </tr>

    //    //if (idx == 0) {
    //    //    let rspan = '' + this.props.currencies.length;
    //    //    return <tr key={this.props.record.id + ':' + cur.id}>
    //    //        <td style={{ textAlign: 'center', width: '10%' }}>{cur.shortname}</td>
    //    //        <td style={{ textAlign: 'right', width: '90%' }}>{this.props.record.fullname}</td>
    //    //    </tr>
    //    //}
    //    //else {
    //    //    return <tr key={this.props.record.id + ':' + cur.id}>
    //    //        <td style={{ textAlign: 'center', width: '10%' }}>{cur.shortname}</td>
    //    //        <td style={{ textAlign: 'right', width: '90%' }}>{this.props.record.fullname}</td>
    //    //    </tr>
    //    //}
    //}


    _renderEntityRow(idx: number) {
        let insList = [...this.props.instruments].sort((a, b) => { return a && b ? (a.pos > b.pos ? 1 : (b.pos > a.pos ? -1 : 0)) : 0; });
        //let insList = this.props.instruments;
        let dlen = insList.length;

        let trStyle = idx == 0 ? { borderBottom: '0.5px solid rgb(221, 221, 221)' } : undefined;

        return <tr key={this.props.record.id} style={trStyle}>
            <td style={{ textAlign: 'center', width: 'calc(50%)' }}>
                {insList.length > 0 && this.state.marginTo ?
                    <table className='table-bdr' style={{ width: '100%' }}><tbody ><tr style={{ width: '100%' }}>
                        {insList.map((x, i) => this._renderInstrumentCol(this.state.marginTo, x, true, i, dlen))}
                    </tr></tbody></table>
                    : (idx == 0) ?
                        <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.processing} onClick={this._onCreateLimits.bind(this, '' + this.props.record.id, this.props.record)}>
                            <RB.Glyphicon glyph="plus" />{' Создать лимиты'}
                        </RB.Button>
                        : undefined
                }
            </td>
            <td style={{ textAlign: 'center', width: 'calc(50%)' }}>
                {insList.length > 0 && this.props.record.marginFrom ?
                    <table className='table-bdr' style={{ width: '100%' }}><tbody ><tr style={{ width: '100%' }}>
                        {insList.map((x, i) => this._renderInstrumentCol(this.props.record.marginFrom, x, false, i, dlen))}
                    </tr></tbody></table>
                    : (idx == 0) ? <span><RB.Label bsStyle="default">{'Не установлено'}</RB.Label></span> : undefined
                }
            </td>
        </tr>

    }

    public render() {
        let bg_color = this.state.modified ? '#9be8d7' : (this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white'));
        //let row_border = this.state.selected ? { borderStyle: 'solid', borderWidth: '2.5px' } : { borderStyle: 'none'};

        //let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : {};
        let crsr = { cursor: 'pointer' };

        let trStyle: React.CSSProperties  = {
            //...{ backgroundColor: bg_color }, ...row_border, ...crsr
            ...{ textAlign: 'right' }, ...{ backgroundColor: bg_color }, ...crsr
            //, ...{ columnSpan: 4 }
        };

        var trClass: string = (this.state.selected ? 'rowselected' : '');
        //REUTER:{this.props.record.reutercode}{', '}Bloomberg:{this.props.record.bloombergcode}

        //let curListTo: (DTO.Currency | undefined)[] = [];
        //let curListFrom: (DTO.Currency | undefined)[] = [];
        //if (this.props.record.marginTo) {
        //    curListTo = this.props.record.marginTo.margins.map(x => { return this.props.currencies.find(obj => { return obj.id == x.idcurrency }) }).sort((a, b) => { return a && b ? (a.shortname > b.shortname ? 1 : (b.shortname > a.shortname ? -1 : 0)) : 0; });           
        //}

        //if (this.props.record.marginFrom) {
        //    curListFrom = this.props.record.marginFrom.margins.map(x => { return this.props.currencies.find(obj => { return obj.id == x.idcurrency }) }).sort((a, b) => { return a && b ? (a.shortname > b.shortname ? 1 : (b.shortname > a.shortname ? -1 : 0)) : 0; });
        //}

        let curList = this.props.currencies;

        let changesMade = false;

        if (this.state.marginTo !== this.props.record.marginTo) {
            changesMade = true;
        }


        return <tr key={this.props.record.id} className={trClass} style={trStyle} onClick={this._onSelectSec.bind(this, '' + this.props.record.id, this.props.record)} >
            <td style={{ textAlign: 'left', width: '20px' }} >
                {this.props.record.marginTo ?
                    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                        <RB.Button title='Закрыть лимиты' disabled={this.state.processing} onClick={this._onRemoveSec.bind(this, '' + this.props.record.id, this.props.record)}><RB.Glyphicon glyph="minus" /></RB.Button>
                    </RB.ButtonGroup>
                    : undefined}
            </td>

            <td style={{ textAlign: 'right', width: '10%'}} >
                {this.props.record.shortname}{' ('}{this.props.record.reutercode}{')'}
                {changesMade ? <span>{' '}<RB.Glyphicon glyph="pencil" /><br/></span>: undefined}
                {changesMade ?
                    <RB.Button type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.processing || !changesMade} onClick={this._onApplyLimitChange.bind(this, '' + this.props.record.id, this.state.marginTo)}>
                        {!this.state.processing ? 'Сохранить' : 'Обработка...'}
                    </RB.Button>
                    : undefined

                }
            </td>

            <td style={{ width:'calc(80%)'}}>
                <table className='table-bdr' style={{ width: '100%' }}>

                    {/*
                    <thead>
                        <tr style={{ width: '100%' }}>
                            <th style={{ textAlign: 'center', width: '50px' }} rowSpan={2}>Валюта</th>
                            <th style={{ textAlign: 'center', width: 'calc(100% - 50px)' }} colSpan={2}>Направление</th>
                        </tr>

                        <tr style={{ width: '100%' }}>
                            <th style={{ textAlign: 'center', width: '50%' }}>Размещение</th>
                            <th style={{ textAlign: 'center', width: '50%' }}>Привлечение</th>
                        </tr>
                    </thead>
                    */}

                    <tbody >
                        {this._renderEntityRow(0)}
                        {/*curList.map((x, i) => this._renderCurrencyRow(x, i)) */}
                </tbody></table>
            </td>

            <td style={{ textAlign: 'left', width: 'calc(10% - 20px)' }} >
                <RB.FormControl componentClass="textarea" placeholder="Alert"
                    value={this.state.marginTo ? (this.state.marginTo.alertnote ? this.state.marginTo.alertnote : '') : ''}
                    id='alertnote'
                    name='alertnote'
                    onChange={this.handleChangeMarginProp}/>
            </td>

            {/*
            <tr>
                <td style={{ textAlign: 'right', width: '20px', gridRowSpan: '2' }} >
                    <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                        <RB.Button title='Исключить' disabled={this.state.processing} onClick={this._onRemoveSec.bind(this, '' + this.props.record.id, this.props.record)}><RB.Glyphicon glyph="minus" /></RB.Button>
                    </RB.ButtonGroup>
                </td>

                <td style={{ textAlign: 'right', width: '10%', gridRowSpan: '2'  }} >
                    {this.props.record.shortname}{'('}{this.props.record.reutercode}{')'}
                </td>
                <td style={{ textAlign: 'right', width: '10%' }}>{this.props.record.marginTo}</td>
                <td style={{ textAlign: 'right', width: 'calc(80% - 30px)' }}>{this.props.record.fullname}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'right', width: '10%' }}>{this.props.record.marginTo}</td>
                <td style={{ textAlign: 'right', width: 'calc(80% - 30px)' }}>{this.props.record.fullname}</td>
            </tr>
            */}

        </tr>
            ;
    }

}
